//接口管理
import http from "../utils/request";

//官网api
let api = {
  // 获取公共的分享内容
  // getShareInfo:() => http.get(`mini/system/globalsetting`),
  // 获取分享的设置参数
  getShareParam: data => http.post(`wechat/signature`, data),
  // 首页数据
  getHome: () => http.get(`api/home`),
  // 游戏列表
  getGameList: () => http.get("api/game/list"),
  // 游戏详情
  getGameDetails: id => http.get(`api/game/detail/${id}`),
  // 攻略详情
  getNewsDetails: id => http.get(`api/raider/detail/${id}`),
  // 招聘信息列表
  getRecruitmentList: (data) => http.get("api/job_offer/list",data),
  // 公共配置
  getSetting:()=>http.get('api/init')
};

export default api;



// WEBPACK FOOTER //
// ./src/api/api.js